import * as React from "react";

import { preventDefaultMouseEvent } from "@app/shared/utility";
import { ViewSelectorKey } from "./viewSelectorKey";

interface ViewSelectorItemProps {
  activeView: ViewSelectorKey;
  children?: React.ReactNode;
  ignoresFilters?: boolean;
  selectorKey: ViewSelectorKey;

  onClick: (key: ViewSelectorKey) => void;
}

class ViewSelectorItem extends React.PureComponent<ViewSelectorItemProps> {
  public render() {
    return (
      <a className={`nav-link${this.props.activeView === this.props.selectorKey ? " active show" : ""}`} data-toggle="tab" href="#" onClick={(e: React.MouseEvent) => preventDefaultMouseEvent(e, () => this.props.onClick(this.props.selectorKey))}>{this.props.children}</a>
    );
  }
}

export { ViewSelectorItem, ViewSelectorItemProps };
